import styled from "styled-components";
import CodePng from "../assets/Images/code.png"

const Box = styled.div`
  width: 100vw;
  height: 100vh;
  background: ${(props) => props.theme.text};
  color: ${(props) => props.theme.body};

  display: flex;
  justify-content: center;
  align-items: center;
`;

const Loading = () => {
  return (
    <Box>
      <img src={CodePng}/>
    </Box>
  );
};

export default Loading;
